/**
 * Fetches tv show data from TMDb using an IMDb ID.
 * @param {string} imdbId - The IMDb ID of the movie.
 * @param {string} apiKey - Your TMDb API key.
 * @returns {Promise<object>} - A promise that resolves to the TMDb movie data.
 */
export const fetchTVShowByImdbId = async (imdbId, apiKey) => {
  const url = `https://api.themoviedb.org/3/find/${imdbId}?api_key=${apiKey}&external_source=imdb_id`;  
    // Example: We Are Lady Parts
    // https://www.imdb.com/title/tt10846104/ 
    // https://api.themoviedb.org/3/find/tt10846104?external_source=imdb_id&api_key=17232028b1bd9032226ab2a4200938c6
             
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(
        `Error fetching tvshow by IMDb ID: ${response.statusText}`,
      );
    }
    const data = await response.json();

    if (data.tv_results	 && data.tv_results	.length > 0) {
      return data.tv_results	[0]; // Return the first tv result
    } else {
      console.error('No tv show found for the provided IMDb ID');
      return null;
    }
  } catch (error) {
    console.error('Failed to fetch tv show by IMDb ID:', error);
    throw error;
  }
};
